export default __webpack_public_path__ + "static/media/nascar-lap.dfba697c.m4a";